import React  from 'react';
//import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { PaginationTotal } from '../../../commons/controls';
import _ from 'lodash';
import moment from 'moment';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';

let node;

const PartnerContent = props => {

  const {
    hasPartner,
    selectedPartner,
    onRowSelect,
    partnerData,
  } = props;

  const renderTable = () => {
    const sizePerPage = (node && node.paginationContext.currSizePerPage) || 25;
    const page = hasPartner ? (1 + Math.floor(partnerData.map(p => p.id).indexOf(selectedPartner[0].id) / sizePerPage)) : 1;

    if(node){
      node.paginationContext.currPage = page;
    }
    
    const selected = hasPartner ? selectedPartner.map(partner => partner.id) : [];
    const selectRow = {
      selected: selected,
      mode: 'radio',
      clickToSelect: true,
      hideSelectColumn: true,
      onSelect: onRowSelect,
      style: { backgroundColor: '#c8e6c9' }
      //style: { background: 'red' }
    }

    const columns = [
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'szulido',
        text: 'Születésnap',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: (cell) => cell ? TimeFormatter.formatDate(new Date(cell)) : ""
      },
      {
        dataField: 'telefonszamok',
        text: 'Telefonszámok',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'email',
        text: 'Email',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'id',
        text: '',
        hidden: true,
      },
    ];

    return (
        <div className="animated fadeIn">
          <BootstrapTable
            ref={ n => node = n }
            bootstrap4
            keyField="id"
            data={partnerData}
            columns={columns}
            bordered={false} 
            selectRow={selectRow}
            filter={filterFactory()}
            pagination={paginationFactory({...Lib.bootstraptableProps, sizePerPage: 10})}
            noDataIndication="Nincs megjelenítendő adat!"
          />
        </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-12">
        {renderTable()}
      </div>
    </div>
  );
}

export default PartnerContent;